import { render, staticRenderFns } from "./CommentTitles.vue?vue&type=template&id=68163ad3"
import script from "./CommentTitles.vue?vue&type=script&lang=js"
export * from "./CommentTitles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports